<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-form ref="userForm" v-model="validUser" :lazy-validation="lazy">
      <v-card :loading="loading">
        <v-card-title class="headline">{{ user.fullName }}</v-card-title>
        <v-card-subtitle>{{ user.username }}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Aree di competenza</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select v-model="selectedList" :items="areas" item-value="id" item-text="description" 
                placeholder="Aree di competenza" no-data-text="Nessuna area presente" :rules="requiredRules"
                multiple chips deletable-chips single-line filled dense required clearable>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" @click="clear()">Annulla</v-btn>
          <v-btn small dark color="green" :loading="loading" @click="save()">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import apiRepository from '../../api/api-repository';
export default {
  name: 'UserForm',
  props: [ 'user' ],

  data: ()=> ({
    lazy: true,
    dialog: false,
    loading: false,
    validUser: true,
    selectedList: [ ],
    areas: [ ],
    requiredRules: [ (v)=> (v != undefined && v.length > 0) || 'Campo obbligatorio' ],
  }),

  methods: {
    
    showActivities(){
      this.activities = (this.areaId) ? this.areas.find((a)=> a.id === this.areaId).activities : [ ];
    },

    async open(){
      this.validUser = true; 
      const res = await apiRepository.area().findAll();
      this.areas = res.data;
      this.selectedList = (this.user.areas && this.user.areas.length > 0) ? this.user.areas.map((x)=> x.id) : [ ];
      if(this.$refs.userForm) this.$refs.userForm.resetValidation();
      this.dialog = true;
    },

    clear(){
      this.$refs.userForm.resetValidation();
      this.dialog = false;
    },

    async save(){
      if(!this.$refs.userForm.validate()) return;
      this.loading = true;

      try{
        const req = { userId: this.user.id, areas: this.selectedList };
        const res = await apiRepository.users().update(req);
        this.loading = false;
        this.clear();
        this.$emit('saved', res);
      }
      catch(e){
        this.loading = false;
      }
    }
  }
}
</script>